import {
  equals,
  find,
  includes,
  indexOf,
  reject,
  slice,
  startsWith,
} from 'ramda';
import { BUSY, busyStart, busyEnd } from 'util/actions';

export default (state = [], { type }) => {
  if (busyStart(type) && !includes(type, state)) {
    return [...state, type];
  }
  if (busyEnd(type)) {
    const foundItem = find(
      (item) => startsWith(slice(0, indexOf(BUSY, item), item), type),
      state
    );
    return reject(equals(foundItem), state);
  }
  return state;
};
